import { useState } from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Label } from "@/components/ui/label";
import { Download } from "lucide-react";
import { API } from "@/lib/api";
import { toast } from "sonner";

const MONTHS = ["Janvier","Février","Mars","Avril","Mai","Juin","Juillet","Août","Septembre","Octobre","Novembre","Décembre"];

export default function AccountingPanel() {
  const now = new Date();
  const [month, setMonth] = useState(now.getMonth() + 1);
  const [year, setYear] = useState(now.getFullYear());

  const download = async () => {
    try {
      const token = localStorage.getItem("hana_admin_token");
      const res = await fetch(`${API}/admin/accounting/${year}/${month}`, { headers: { Authorization: `Bearer ${token}` } });
      if (!res.ok) throw new Error("Erreur serveur");
      const blob = await res.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url; a.download = `hanamiya-${year}-${String(month).padStart(2,"0")}.pdf`;
      a.click(); URL.revokeObjectURL(url);
      toast.success("PDF généré");
    } catch (e) { toast.error("Erreur de génération"); }
  };

  const years = Array.from({ length: 6 }, (_, i) => now.getFullYear() - i);

  return (
    <div data-testid="accounting-panel" className="max-w-2xl">
      <h1 className="font-display text-4xl mb-2">Comptabilité</h1>
      <p className="text-muted-foreground mb-8">Génération du rapport mensuel — chiffre d'affaires net, TVA payée, produits vendus.</p>

      <div className="bg-white border border-border rounded-sm p-8">
        <div className="grid sm:grid-cols-2 gap-4 mb-6">
          <div>
            <Label className="text-xs uppercase tracking-wider text-muted-foreground mb-2 block">Mois</Label>
            <Select value={String(month)} onValueChange={(v) => setMonth(Number(v))}>
              <SelectTrigger data-testid="month-select" className="h-12"><SelectValue /></SelectTrigger>
              <SelectContent>{MONTHS.map((m, i) => <SelectItem key={i+1} value={String(i+1)}>{m}</SelectItem>)}</SelectContent>
            </Select>
          </div>
          <div>
            <Label className="text-xs uppercase tracking-wider text-muted-foreground mb-2 block">Année</Label>
            <Select value={String(year)} onValueChange={(v) => setYear(Number(v))}>
              <SelectTrigger data-testid="year-select" className="h-12"><SelectValue /></SelectTrigger>
              <SelectContent>{years.map(y => <SelectItem key={y} value={String(y)}>{y}</SelectItem>)}</SelectContent>
            </Select>
          </div>
        </div>
        <button onClick={download} data-testid="download-pdf-btn" className="w-full bg-primary text-white py-4 rounded-sm hover:bg-primary/90 flex items-center justify-center gap-3">
          <Download size={18} /> Télécharger le PDF {MONTHS[month - 1]} {year}
        </button>
        <p className="text-xs text-muted-foreground mt-4 text-center">
          Le rapport exclut les commandes supprimées et ne contient aucune donnée personnelle client.
        </p>
      </div>
    </div>
  );
}
